import React ,{ useEffect, useState } from "react";
import { Link,useNavigate,useParams } from "react-router-dom";
import { rquestions ,rules} from "../../apis/urls";
import axios from "axios";
import {decode} from 'html-entities';
import { $ } from "react-jquery-plugin";



const CoachAnswerslist =()=> {

    useEffect( ()=> {
        $('html,body').animate({ scrollTop: 0 }, 'fast');
        AnswerListing();
    },[])


    const { id } = useParams();
    // let navigate = useNavigate();

    
    let navigate = useNavigate();


    const [result,setResult] = useState([]);
    const [rname,setRname] = useState('');
    const [tmark,setTmark] = useState('');
    const [mark,setMark] = useState('');



    const AnswerListing = () => {

        

        let token = "Bearer "+localStorage.getItem('token');
        
        
        const instance = axios.create({

            baseURL: rules+'/coachanswers/'+id,

            timeout: 1000000,

            headers: {'authorization': token}

          });
          
          instance.get('').then((response) =>{
            
            setResult(response.data.data);
            setMark(response.data.score); 
            console.log('resultssssss',response.data.score)
                     
          }).catch((error) =>{
            
            console.log('error',error.message)
            

          });
    }
    let coachid = localStorage.getItem('coachid');
    
    let sl =1
    return(<>
             <div>
            <aside class="right-side areas">
                <div class="content-area dash-contentss">
                    <div class="page-title-wrpr">
                        <div class="page-title-left-column">
                            <h2 class="page-title"> Coach Answers</h2>
                        </div>
                    </div>
                    
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                            <li class="breadcrumb-item active" aria-current="page"><Link to={"/coach_view/"+coachid}>Coach</Link></li>
                            <li class="breadcrumb-item active" aria-current="page">Answers</li>
                        </ol>
                        
                    </nav>
                   
                    <div className="row">
                        <div className="col-md-8"><b>Score:&nbsp;&nbsp;{mark.user_totalmarks} / {mark.totalmarks}</b></div>
                        <div className="col-md-3">
                            <span>
                                <i class="icon-tick" style={{ fontSize: '20px', color: 'green' }}></i>
                                : Correct Answer&nbsp;&nbsp;
                            </span>,
                            <span>
                                <i class="icon-close1" style={{ fontSize: '20px', color: 'red' }}></i>&nbsp;
                                : Incorrect Answer
                            </span>
                        </div>   
                    </div>




                <div>
                
                    <div class="containers" style={{overflow:'auto'}}>


                {result?
                <table class="table table-rules">
                    <thead>
                        <tr className="rules-table-head">
                            <th scope="col">Sl.No</th>
                            <th scope="col">Questions</th>
                            <th scope="col">Anwers</th>
                            <th scope="col">Status</th>
                        </tr>
                    </thead>
                    {                   
                        result?.map((item,index) =>(
                            <tbody className="rules-table-content">

                                <tr>
                                    <td>{sl++}</td>
                                    <td>{item.rulequestion.question}</td>
                                    <td className="col-md-6">{decode(item.answer)}</td>
                                    <td>
                                        {item.answer === item.rulequestion.correct_answer ? (
                                            <span style={{ fontSize: '25px', color: 'green' }}><i class="icon-tick"></i></span>

                                            

                                        ) : (
                                            <span style={{ fontSize: '25px', color: 'red' }}><i class="icon-close1"></i></span>

                                        )}
                                    </td>
                                </tr>
                            </tbody>

                        ))               
                    }

                </table>:null}


                </div>
                </div>

            </div>

                
            </aside>
        </div>

    </>)
}

export default CoachAnswerslist;